(function () {
  function initBanner(root) {
    let settings = {};
    try {
      settings = JSON.parse(root.getAttribute('data-section-settings')) || {};
    } catch (e) {
      settings = {};
    }

    const storageKey = 'banner-popup-closed-' + (settings.sectionId || 'default');

    // Already dismissed in this tab session — don't show again until a new tab is opened.
    if (sessionStorage.getItem(storageKey) === 'true') {
      return;
    }

    function close() {
      root.classList.remove('is-visible');
      root.setAttribute('aria-hidden', 'true');
      try {
        sessionStorage.setItem(storageKey, 'true');
      } catch (e) {
        /* sessionStorage unavailable (e.g. private mode) — ignore */
      }
    }

    function open() {
      root.classList.add('is-visible');
      root.setAttribute('aria-hidden', 'false');
    }

    root.querySelectorAll('[data-action="close-banner"]').forEach(function (el) {
      el.addEventListener('click', function (event) {
        event.preventDefault();
        close();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-visible')) {
        close();
      }
    });

    open();
  }

  function ready() {
    document.querySelectorAll('[data-section-type="banner-popup"]').forEach(initBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
